module.exports = __webpack_public_path__ + "img/autospin_btn.69f17295.png";